<template>
  
  <Intro :onModalOpen="onModalOpen" />

  <Steps />

  <General />

  <MarketPosition />

  <CrossworkPartnership />

  <Markets />

  <MarketPresence />

  <Comparison />

  <Calculator />

  <Solution />

  <Highlights />

  <Outro :onModalOpen="onModalOpen" />

  <ContactInvestorModal ref="investorContact" />

  <ContactGeneralModal ref="generalContact" />

</template>

<script>

import Intro from "../components/invest/Intro";
import Outro from "../components/invest/Outro";
import Steps from "../components/invest/Steps";
import General from "../components/invest/General";
import Highlights from "../components/invest/Highlights";
import Solution from "../components/invest/Solution";
import MarketPosition from "../components/invest/MarketPosition";
import CrossworkPartnership from "../components/invest/CrossworkPartnership";
import Markets from "../components/invest/Markets";
import Comparison from "../components/invest/Comparison";
import MarketPresence from "../components/invest/MarketPresence";
import Calculator from "../components/invest/Calculator";

import ContactGeneralModal from "../components/invest/ContactGeneralModal";
import ContactInvestorModal from "../components/invest/ContactInvestorModal";

export default {
  components: { Intro, Outro, Steps, Highlights, Solution, General, MarketPosition, CrossworkPartnership, Markets, Comparison, MarketPresence, Calculator, ContactGeneralModal, ContactInvestorModal }, 
  methods: {
    onModalOpen(type) {
      if (type == 'investor') {
        this.$refs.investorContact.open();
      } else {
        this.$refs.generalContact.open();
      }
    }
  },
};
</script>
